exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tabbar-ios-safe-area{position:fixed;bottom:0;height:env(safe-area-inset-bottom);width:100%;background:#fff}\n", ""]);

